import {Component, ElementRef} from '@angular/core';
import {Http} from '@angular/http';
import {ActivatedRoute} from '@angular/router';
import {ToasterService} from 'angular2-toaster/angular2-toaster';

@Component({
    selector: 'role-page',
    templateUrl: 'role.template.html',
    styleUrls: ['role.css']
})
export class RoleComponent {


}


// WEBPACK FOOTER //
// ./src/app/views/role/role.component.ts